import { StringUtils, engineComponent } from "neo-common";
import { ComponentTypes } from "../../ComponentTypes";
import { TextElementAttributes } from "../../ComponentAttributes";

/**
 * The image text element render bitmap font to text.
 * Example:
 *   <TextElement Class="TextElement" Font="fontName" Text="09123456789.,+" X="960" Y="540" TextAlign="center" TextBaseline="middle" />
 *
 * @class TextElement
 * @extends BaseElement
 */
@engineComponent(ComponentTypes.DisplayObject)
export class TextElement extends PIXI.Text {
    private _uid: string;
    private _cloned: boolean;
    private __destroyed: boolean;

    constructor() {
        super();

        this.text = "";

        if (DEBUG) {
            if (PERFDEBUG_ENABLED) {
                this._uid = PerfDebug.generateElementUID(this);
                PerfDebug.newElement(this, this.getDebugInfo());
            }
        }
    }

    /**
     * Get attributes from xml and set up supported properties.
     * @method create
     * @param node is Element from xml
     * @return void
     */
    create(node: Element) {
        if (this.name == null) {
            this.name = node.nodeName;
        }

        if (node.hasAttribute(TextElementAttributes.FONT)) {
            this.style.fontFamily = node.getAttribute(TextElementAttributes.FONT);
        }

        this.updateByNode(node);
    }

    /**
     * @todo Najst miesta, kde sa vola metoda create(). Ak by bolo vhodne, aby sa tam volala metoda update(), treba volat ju. Tomu treba prisposobit aj obsah metody.
     *
     * @param node
     */
    public updateByNode(node: Element): void {
        if (node.hasAttribute(TextElementAttributes.TEXT)) {
            this.text = node.getAttribute(TextElementAttributes.TEXT);
        }

        if (node.hasAttribute(TextElementAttributes.TEXT_ALIGN)) {
            //this.style.align = node.getAttribute(TextElementAttributes.TEXT_ALIGN);
        }

        if (node.hasAttribute(TextElementAttributes.TEXT_BASELINE)) {
            //this.textBaseline = node.getAttribute(TextElementAttributes.TEXT_BASELINE);
            /*switch (node.getAttribute(TextElementAttributes.TEXT_BASELINE)) {
                case TextElementAttributes.TEXT_BASELINE_VALUE.MIDDLE:
                    this.position.y = this.position.y - this.parent.height / 2;
                    break;
                case TextElementAttributes.TEXT_BASELINE_VALUE.BOTTOM:
                    this.position.y = -this.parent.height;
                    break;
            }*/
        }

        if (node.hasAttribute(TextElementAttributes.SIZE)) {
            this.style.fontSize = parseInt(node.getAttribute(TextElementAttributes.SIZE));
        }

        if (node.hasAttribute(TextElementAttributes.ALPHA)) {
            this.alpha = parseFloat(node.getAttribute(TextElementAttributes.ALPHA));
        }

        if (node.hasAttribute(TextElementAttributes.ROTATION)) {
            this.rotation = parseInt(node.getAttribute(TextElementAttributes.ROTATION));
        }

        if (node.hasAttribute(TextElementAttributes.START_ROTATION)) {
            if (node.getAttribute(TextElementAttributes.START_ROTATION) === TextElementAttributes.START_ROTATION) {
                this.rotation = Math.floor(Math.random() * 360) / 100;
            }
        }

        if (node.hasAttribute(TextElementAttributes.SCALE_X)) {
            this.scale.x = parseFloat(node.getAttribute(TextElementAttributes.SCALE_X));
        }

        if (node.hasAttribute(TextElementAttributes.SCALE_Y)) {
            this.scale.y = parseFloat(node.getAttribute(TextElementAttributes.SCALE_Y));
        }

        if (node.hasAttribute(TextElementAttributes.SCALE)) {
            this.scale.x = parseFloat(node.getAttribute(TextElementAttributes.SCALE));
            this.scale.y = parseFloat(node.getAttribute(TextElementAttributes.SCALE));
        }

        if (node.hasAttribute(TextElementAttributes.X)) {
            this.position.x = parseInt(node.getAttribute(TextElementAttributes.X));
        }

        if (node.hasAttribute(TextElementAttributes.Y)) {
            this.position.y = parseInt(node.getAttribute(TextElementAttributes.Y));
        }

        if (node.hasAttribute(TextElementAttributes.PIVOT_X)) {
            this.pivot.x = parseInt(node.getAttribute(TextElementAttributes.PIVOT_X));
        }

        if (node.hasAttribute(TextElementAttributes.PIVOT_Y)) {
            this.pivot.y = parseInt(node.getAttribute(TextElementAttributes.PIVOT_Y));
        }

        if (node.hasAttribute(TextElementAttributes.VISIBLE)) {
            this.visible = StringUtils.parseBoolean(node.getAttribute(TextElementAttributes.VISIBLE));
        }

        if (node.hasAttribute(TextElementAttributes.TINT)) {
            if (node.getAttribute(TextElementAttributes.TINT) === "0") {
                this.style.fill = null;
            } else {
                this.style.fill = parseInt(node.getAttribute(TextElementAttributes.TINT), 16);
            }
        }

        // NOTE(psulek) Do not join these two ifs into one, required 2 ifs for webpack optimization
        if (DEBUG) {
            if (PERFDEBUG_ENABLED) {
                PerfDebug.updateDebugInfo(this, this.getDebugInfo());
            }
        }
    }

    /**
     * Marks element as cloned
     */
    markAsCloned(): void {
        this._markAsCloned();
    }

    /**
     * Marks element as cloned
     */
    protected _markAsCloned(): void {
        this.assertDestroyed("markAsCloned()");
        this._cloned = true;

        // NOTE(psulek) Do not join these two ifs into one, required 2 ifs for webpack optimization
        if (DEBUG) {
            if (PERFDEBUG_ENABLED) {
                PerfDebug.clone(this);

                PerfDebug.updateDebugInfo(this, this.getDebugInfo());
            }
        }
    }

    protected assertDestroyed(method: string): void {
        if (DEBUG) {
            if (this.__destroyed) {
                throw new Error(`${this.componentName}[${this.uid}] was already destroyed, calling method '${method}'`);
            }
        }
    }

    /**
     * @protected componentName - component type name.
     * @returns {string}
     */
    public get componentName(): string {
        return (this as any).__componentName__;
    }

    /**
     * @property uid - unique identifier of element.
     * @returns {string}
     */
    public get uid(): string {
        return this._uid;
    }

    getDebugInfo(): string {
        if (DEBUG) {
            let debugInfoFn = (this as any).debugInfo;
            return debugInfoFn ? debugInfoFn.call(this) : `${this.uid}\nName: [${this.name}]`;
        }
        return "";
    }

    debugInfo(): string {
        if (DEBUG) {
            let result = `${this.uid}\nName: [${this.name}]`;

            return result;
        }
        return "";
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/Components/Elements/Texts/TextElement.ts
 **/